import config from "../../store/sqftConfig";
import {enableRegularMode, enableSlabMode, getDimensionsDependingOnShapePositions} from "../../store/canvasHelper";
import store from "../../../../../../store";
import SqftStore from "../../store/sqftStore";
import {showSlabTool} from "../../../../../../actions/sqftSlabFunctions";
import SlabWorkspace from "../slab/slabWorkspace";
import {renderSlabRightPart} from "../slab/sqftSlabDraw";
import sqftEventManager from "../../store/sqftEventManager";
import sqftImageManager from "../../store/sqftImageManager";
import sqftShapeManager from "../../store/sqftShapeManager";

export default class ResultImages {
  workspace;
  dimensionsMultiplier = 3;

  constructor(workspace) {
    this.workspace = workspace;
  }

  getCanvasImageScaled = (newScale = config.defaultScale) => {
    const isSlabMode = SqftStore.isSlabMode();
    let shouldReturnToSlabMode = false;
    if (isSlabMode) {
      enableRegularMode();
      store.dispatch(showSlabTool(false));
      shouldReturnToSlabMode = true;
    }
    let [imageWidth, imageHeight] = getDimensionsDependingOnShapePositions(this.workspace);
    let centerPoint = {width: imageWidth, height: imageHeight};

    let resultImage = this.getCanvasScreen(
      newScale,
      0,
      0,
      imageWidth,
      imageHeight,
      centerPoint,
      this.updateCanvas
    );
    //todo not needed to change back
    void shouldReturnToSlabMode
    // if (shouldReturnToSlabMode) {
    //   enableSlabMode();
    //   store.dispatch(showSlabTool(true));
    // }

    return resultImage;
  };

  getSlabResultImage = (newScale = config.defaultScale) => {
    const isSlabMode = SqftStore.isSlabMode();
    let shouldReturnToRegularMode = false;
    if (!isSlabMode) {
      enableSlabMode();
      store.dispatch(showSlabTool(true));
      shouldReturnToRegularMode = true
    }
    let [imageWidth, imageHeight] = getDimensionsDependingOnShapePositions(this.workspace);
    let centerPoint = {width: 0, height: imageHeight};

    let resultImage = this.getCanvasScreen(
      newScale,
      0,
      0,
      imageWidth,
      imageHeight,
      centerPoint,
      this.updateCanvasSlab
    );

    if (shouldReturnToRegularMode) {
      enableRegularMode();
      store.dispatch(showSlabTool(false));
    }

    return resultImage
  };

  getSlabCalcImage = (newScale = config.defaultScale) => {
    const isSlabMode = SqftStore.isSlabMode();
    let shouldReturnToRegularMode = false;
    if (!isSlabMode) {
      enableSlabMode();
      store.dispatch(showSlabTool(true));
      shouldReturnToRegularMode = true
    }
    SlabWorkspace.disableSlabImages();
    let [imageWidth, imageHeight] = getDimensionsDependingOnShapePositions(this.workspace);
    let centerPoint = {width: imageWidth, height: imageHeight};

    let resultImage = this.getCanvasScreen(
      newScale,
      0,
      0,
      imageWidth,
      imageHeight,
      centerPoint,
      this.updateCanvas
    );

    if (shouldReturnToRegularMode) {
      enableRegularMode();
      store.dispatch(showSlabTool(false));
    }
    // else {
    //   SlabWorkspace.init();
    // }

    return resultImage
  }

  getCanvasApplianceImages = () => {
    const applianceImages = sqftImageManager.getAppliancesThatShouldRenderMeasurementsInsideTheShape();

    return applianceImages.reduce((result, applianceImage) => {
      const outerShape = applianceImage.getOuterShape();
      if (outerShape) {
        const outerShapePosition = outerShape.getPosition();
        let shapesPoints = outerShape.getPoints();
        let pointsMinMax = sqftShapeManager.getMinMaxPoints(shapesPoints, false);

        const offset = 200;
        const startPoint = {
          x: (outerShapePosition.x + pointsMinMax.minX) * config.defaultScaleExport - offset,
          y: (outerShapePosition.y + pointsMinMax.minY) * config.defaultScaleExport - offset
        }

        // const imagePosField = applianceImage.getPosField();
        // console.log("imagePosField", imagePosField);
        // const imageCenter = applianceImage.getCenter();
        // console.log("imageCenter", imageCenter);
        //const imagePosition = applianceImage.getPosition();
        // console.log("imagePosition", imagePosition);
        // const workspaceCenter = this.workspace.getCenter();
        // console.log("workspaceCenter", workspaceCenter);
        // const workspacePosition = this.workspace.getPosition();
        // console.log("workspacePosition", workspacePosition);
        //console.log("pointsMinMax", pointsMinMax);

        const canvasImage = this.getCanvasImage(config.defaultScaleExport,
          startPoint,
          pointsMinMax.maxX * config.defaultScaleExport + offset * 2,
          pointsMinMax.maxY * config.defaultScaleExport + offset * 2
        );
        result.push(canvasImage);
      }
      return result;
    }, []);
  }

  getCanvasImage = (newScale = config.defaultScaleExport, startPoint, imageWidth, imageHeight) => {
    const isSlabMode = SqftStore.isSlabMode();
    if (isSlabMode) {
      enableRegularMode();
      store.dispatch(showSlabTool(false));
    }

    return this.getCanvasScreen(
      newScale,
      0,
      0,
      imageWidth,
      imageHeight,
      startPoint,
      this.updateCanvasAtStartPoint
    );
  };

  getCanvasScreen = (newScale, startClippingX, startClippingY, clippingWidth, clippingHeight, centerPoint, updateCallback) => {
    // fix transparent background by drawing canvas onto another canvas with a white background
    // https://stackoverflow.com/questions/18609715/html5-canvas-todataurl-image-has-no-background-color

    const srcCanvas = this.workspace.getCanvas();
    const temp = {
      scale: config.scale,
      width: srcCanvas.width,
      height: srcCanvas.height,
    };
    updateCallback(srcCanvas, newScale, clippingWidth, clippingHeight, centerPoint);

    //create a dummy CANVAS
    const destinationCanvas = document.createElement("canvas");
    const destCtx = destinationCanvas.getContext('2d');
    destinationCanvas.width = srcCanvas.width ;
    destinationCanvas.height = srcCanvas.height ;

    //create a rectangle with the desired color
    destCtx.fillStyle = "#FFFFFF";
    destCtx.fillRect(0,0, destinationCanvas.width, destinationCanvas.height);

    //draw the original canvas onto the destination canvas
    if (clippingWidth > srcCanvas.width) clippingWidth = srcCanvas.width;
    if (clippingHeight > srcCanvas.height) clippingHeight = srcCanvas.height;

    destCtx.drawImage(
      srcCanvas,
      startClippingX,
      startClippingY,
      clippingWidth,
      clippingHeight,
      0,
      0,
      srcCanvas.width,
      srcCanvas.height
    );

    //restore canvas
    updateCallback(srcCanvas, temp.scale,  temp.width, temp.height, centerPoint);

    return destinationCanvas.toDataURL();
  }

  updateCanvas = (srcCanvas, scale, width, height, centerPoint) => {
    srcCanvas.width = width;
    srcCanvas.height = height;
    config.scale = scale;
    this.workspace.setCenter(centerPoint.width, centerPoint.height); // return canvas to default position
    sqftEventManager.trigger(sqftEventManager.events.RENDER);
    sqftEventManager.trigger(sqftEventManager.events.RENDER);
  }

  updateCanvasAtStartPoint = (srcCanvas, scale, width, height, startPoint) => {
    srcCanvas.width = width;
    srcCanvas.height = height;
    config.scale = scale;
    this.workspace.setPosition(startPoint); // return canvas to default position

    sqftEventManager.trigger(sqftEventManager.events.RENDER);
    sqftEventManager.trigger(sqftEventManager.events.RENDER);
  }

  updateCanvasSlab = (srcCanvas, scale, width, height, centerPoint) => {
    srcCanvas.width = width;
    srcCanvas.height = height;
    config.scale = scale;
    this.workspace.setCenter(centerPoint.width, centerPoint.height); // return canvas to default position
    renderSlabRightPart(sqftEventManager.getCtx(), true);
  }
}
